const groupThousands = (value: number): string =>
    Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const formatMoney = (value: number): string => `$${groupThousands(value)}`

export const formatRange = (lo: number, hi: number): string => `${formatMoney(lo)}–${formatMoney(hi)}`

export const formatNumber = (value: number): string => groupThousands(value)

export const pad = (value: number): string => value.toString().padStart(2, '0')
